import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  BaseText,
  Link,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Ref, computed, inject, onMounted, ref } from 'vue';
import { Advisor } from '@/modules/onboarding/signup/types';
import { trackQrCodeView } from '@/modules/onboarding/signup/helpers/track-events';


export default /*#__PURE__*/_defineComponent({
  __name: 'FinishedFormStep',
  setup(__props) {

const firstName = inject('firstName');
const storeHref = ref('');
const userHaveAdvisor = inject('userHaveAdvisor') as Ref<boolean>;
const advisor = inject('advisor') as Ref<Advisor>;
const isMobile = inject('isMobile') as Ref<boolean>;

const appStoreLink =
  'https://apps.apple.com/br/app/warren-investimentos/id1114394063';
const playStoreLink = advisor.value?.email
  ? `https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren&referrer=utm_source${encodeURIComponent(
      `=${advisor.value?.email}`
    )}`
  : 'https://play.google.com/store/apps/details?id=com.oiwarren.oiwarren';

const href = computed(() => {
  return navigator.userAgent.includes('iPhone') ||
    navigator.userAgent.includes('iPad')
    ? appStoreLink
    : playStoreLink;
});

function mountStoreHref() {
  const currentUrl = window.location.href;
  const baseUrl = currentUrl.split('/#/')[0];
  storeHref.value = userHaveAdvisor.value
    ? `${baseUrl}/#/mobile?advisor=${advisor.value?.email}`
    : `${baseUrl}/#/mobile`;
}

onMounted(() => {
  mountStoreHref();
  trackQrCodeView();
});

return { __sfc: true,firstName, storeHref, userHaveAdvisor, advisor, isMobile, appStoreLink, playStoreLink, href, mountStoreHref, Heading, BaseText, Link, ButtonPrimary, NebraskaColors }
}

})